module.exports = __webpack_public_path__ + "static/media/backgroundDark2.773b37a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common_images/backgroundDark2.jpg
// module id = 53
// module chunks = 0